<template>
  <div class="wrappersss">
    <!--慧定投-->
    <FixIncomeList v-if="bfundType === '0'"  />

    <!--没有-->
    <FixNoIncomeList v-if="bfundType === '1'"  />

  </div>
</template>

<script>
import FixIncomeList from '@/components/Mark-FixIncomeList.vue';
import StoreManger from '@/utils/FundHQJHManger';
import FixNoIncomeList from '@/components/Mark-FixNoInList.vue';

export default {
  name: 'FixList',
  components: {
    FixNoIncomeList,
    FixIncomeList,
  },
  props: {},
  watch: {},
  data() {
    return {
      fundCode: '',
      fundType: '',
      bfundType: '0',
    };
  },
  computed: {
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    const fundinfo = StoreManger.getFundJJXQ();
    if (!fundinfo) {
      return;
    }
    const bType = fundinfo.BFUNDTYPE;
    if (bType === '001' || bType === '002' || bType === '007') {
      this.bfundType = '0';
    } else {
      this.bfundType = '1';
    }
  },
  mounted() {},
  methods: {
    render() {

    },
    handleDefault() {
      this.handleData(null);
    },
    handleData() {},
  },
};
</script>

<style lang="less" scoped>
</style>
